/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForComplianceStandard extends models.ScheduleExecutionParameterServiceAccountBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForComplianceStandard");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForComplianceStandard.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForComplianceStandard>): ScheduleExecutionParameterForComplianceStandard {
        let obj = Object.assign(new ScheduleExecutionParameterForComplianceStandard(), model);
        ScheduleExecutionParameterForComplianceStandard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForComplianceStandard>): ScheduleExecutionParameterForComplianceStandard {
        if (!model) return null;
        return ScheduleExecutionParameterForComplianceStandard.newInstance(<ScheduleExecutionParameterForComplianceStandard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForComplianceStandard) {
        if (!obj) return;

        models.ScheduleExecutionParameterForComplianceStandard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForComplianceStandard): boolean {
        if (models.ScheduleExecutionParameterServiceAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForComplianceStandard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
